import React from 'react';
import { withRouter, Route} from 'react-router-dom';

import './index.css' 

const Analyze = ( {match, history} ) => {
    history.push(match.url + '/dashboard')
    return (
        <div></div>
    )
}


export default withRouter(Analyze)



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/index.js